import get from 'lodash/get';

const styles = ({ margin, color } = {}) => ({
  nameContainer: {
    margin: `${get(margin, 'm2')} ${get(margin, 'm4')} ${get(margin, 'm2')} ${get(margin, 'm0')} !important`,
    width: 230,
  },
  helpIcon: {
    color: color.primaryButtonBackground,
    marginLeft: 6,
    marginTop: 3,
    height: 18,
    width: 18,
  },
  helpIconContainer: {
    display: 'flex',
  },
  fieldContainer: {
    display: 'flex',
    width: 150,
  },
  hideLabel: {
    width: '0px !important',
  },
  selectField: {
    marginTop: '13px !important',
  },
  tickMark: {
    color: color.primaryButtonBackground,
    fontWeight: 'bold',
  },
});

export default styles;
